/**
 * VLX Collapse
 * Vanilla JS replacement for Bootstrap 3 collapse
 */

(function () {
    "use strict";

    const VLX = (window.VLX = window.VLX || {});
    const TRANSITION_DURATION = 350;

    class Collapse {
        constructor(element, options = {}) {
            this.element = element;
            this.options = Object.assign({ toggle: true }, options);
            this.trigger = document.querySelectorAll(
                `[data-toggle="collapse"][href="#${element.id}"],
         [data-toggle="collapse"][data-target="#${element.id}"]`
            );

            this.transitioning = false;

            if (this.options.parent) {
                this.parent = document.querySelector(this.options.parent);
                this.initParent();
            } else {
                this.updateAria();
            }

            if (this.options.toggle) {
                this.toggle();
            }
        }

        dimension() {
            return this.element.classList.contains("width") ? "width" : "height";
        }

        show() {
            if (this.transitioning || this.element.classList.contains("open")) return;

            if (!this.dispatch("show")) return;

            const dimension = this.dimension();
            this.transitioning = true;

            this.element.classList.remove("collapse");
            this.element.classList.add("collapsing");
            this.element.style[dimension] = "0px";
            this.element.setAttribute("aria-expanded", "true");

            this.updateTrigger(true);

            const scrollSize = dimension === "height" ? this.element.scrollHeight : this.element.scrollWidth;

            requestAnimationFrame(() => {
                this.element.style[dimension] = scrollSize + "px";
            });

            this.afterTransition(() => {
                this.element.classList.remove("collapsing");
                this.element.classList.add("collapse", "open");
                this.element.style[dimension] = "";
                this.transitioning = false;
                this.dispatch("shown");
            });
        }

        hide() {
            if (this.transitioning || !this.element.classList.contains("open")) return;
            if (!this.dispatch("hide")) return;

            const dimension = this.dimension();
            this.transitioning = true;

            this.element.style[dimension] = this.element.getBoundingClientRect()[dimension] + "px";

            // force reflow
            this.element.offsetHeight;

            this.element.classList.add("collapsing");
            this.element.classList.remove("collapse", "open");
            this.element.setAttribute("aria-expanded", "false");

            this.updateTrigger(false);

            requestAnimationFrame(() => {
                this.element.style[dimension] = "0px";
            });

            this.afterTransition(() => {
                this.transitioning = false;
                this.element.classList.remove("collapsing");
                this.element.classList.add("collapse");
                this.dispatch("hidden");
                this.element.style[dimension] = "";
            });
        }

        toggle() {
            this.element.classList.contains("open") ? this.hide() : this.show();
        }

        updateTrigger(isOpen) {
            this.trigger.forEach((el) => {
                el.classList.toggle("collapsed", !isOpen);
                el.setAttribute("aria-expanded", String(isOpen));
            });
        }

        updateAria() {
            const isOpen = this.element.classList.contains("open");
            this.element.setAttribute("aria-expanded", String(isOpen));
            this.updateTrigger(isOpen);
        }

        initParent() {
            const triggers = this.parent.querySelectorAll('[data-toggle="collapse"][data-parent]');

            triggers.forEach((trigger) => {
                const target = getTarget(trigger);
                if (target) {
                    const isOpen = target.classList.contains("open");
                    trigger.classList.toggle("collapsed", !isOpen);
                    trigger.setAttribute("aria-expanded", String(isOpen));
                }
            });
        }

        afterTransition(callback) {
            setTimeout(callback, TRANSITION_DURATION);
        }

        dispatch(name) {
            const event = new CustomEvent(`vlx.collapse.${name}`, {
                cancelable: true,
                detail: { element: this.element },
            });
            return this.element.dispatchEvent(event);
        }
    }

    function getTarget(trigger) {
        const target = trigger.getAttribute("data-target") || trigger.getAttribute("href");

        if (!target || !target.startsWith("#")) return null;
        return document.querySelector(target);
    }

    // Data API
    document.addEventListener("click", function (e) {
        const trigger = e.target.closest('[data-toggle="collapse"]');
        if (!trigger) return;

        const target = getTarget(trigger);
        if (!target) return;

        e.preventDefault();

        let instance = target.__vlxCollapse;
        if (!instance) {
            instance = new Collapse(target, {
                parent: trigger.getAttribute("data-parent"),
            });
            target.__vlxCollapse = instance;
        }

        instance.toggle();
    });

    VLX.Collapse = Collapse;
})();
